import {FilterMatchMode, FilterOperator} from "primereact/api";

export const statusFilterProperties = {
    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
    'dataStatus.name': {value: null, matchMode: FilterMatchMode.IN},
    'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
    'allTags': {value: null, matchMode: FilterMatchMode.IN},
    'modelVersionName': {
        operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
    }
};

export const getDefaultColumnFilter = (col) => {
    const def = statusFilterProperties[col];
    if (!def) return null;
    return JSON.parse(JSON.stringify(def));
};